// extracted by mini-css-extract-plugin
module.exports = {"logo":"LogoHeader_logo__30MFe","link":"LogoHeader_link__1B4eH","name":"LogoHeader_name__3Fmi3"};